import _ from 'underscore';

export default {

	props: {
		module: {
			type: Object,
		},
		formId: {},
		field: {
			type: Object,
			required: true,
		},
		tags: {
			type: Array,
			default: () => ([]),
		},
		options: {
			type: Object | Array,
			default: () => ({}),
		},
		showErrors: {
			type: Boolean,
			default: false,
		},
		value: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			inputVal: this.value[ this.field.slug ],

			// Validation rules
			rules: {},
			errors: [],

			// How large can uploaded files be?
			maxFileSize: (process.env.MIX_MAX_FILESIZE_MB || 8) * 1024 * 1024,

			forcedValidationRules: {},
		};
	},

	computed: {

		isSuper: function() {
			return this.$root.isSuperAdmin;
		},

		hasValidationErrors: function() {
			return this.errors.length > 0;
		},

		/**
		 * Get the validation rules for this field
		 *
		 * @returns {Array}
		 */
		fieldValidation() {
			let validationRules = {};

			if (this.field.custom_validation) {
				validationRules = {
					...validationRules,
					...this.field.custom_validation.split('|').reduce((map, rule) => {
						let [ruleName, ...options] = rule.split(':');

						map[ ruleName ] = options;

						return map;
					}, {}),
				};
			}

			validationRules = {
				...this.forcedValidationRules,
				...validationRules,
			};

			return validationRules;
		},

		isRequired() {
			return (this.field.custom_validation.indexOf('required') !== -1);
		},
	},

	mounted() {
		// Listen for requests to validate this field
		this.addRootListener(this.formId + '_validate-fields', this.validate);
		// this.addRootListener(this.formId + '_server_validation_error', this.validate);

		this._setDefaultValidationRules();
	},

	watch: {
		inputVal(val) {
			if (this.showErrors) this.errors = this.validate();

			this.$set(this.value, this.field.slug, val);

			this.$emit('input', this.value);
		},
	},

	methods: {
		/**
		 * Get the name of the field to output. May include things such as * for required fields
		 *
		 * @param field
		 * @returns {*}
		 */
		getFieldName(field) {
			return this._getPrefix(field) + field.name;
		},

		_getPrefix(field) {
			let prefix = '';

			if (field.type === 'photo' && (this.row && typeof this.row[ field.slug + '_filename' ] === 'string' && this.row[ field.slug + '_filename' ].length > 0)) {
				prefix += 'Replace ';
			}

			if (this.isRequired) {
				prefix += '*';
			}

			return prefix;
		},

		/**
		 * Sets a rule that will be run to validate this field.
		 *
		 * @param name - the rule name, e.g. 'required'
		 * @param callback - This callback must either return bool true or a string of the error message
		 */
		addValidationRule(name, callback) {
			this.rules[ name ] = callback;
		},

		/**
		 * Checks validation rules on this field
		 *
		 * @returns {Array} of errors with this field
		 */
		validate() {
			this.errors = [];
			Object.keys(this.fieldValidation).forEach(ruleName => {
				if (typeof this.rules[ ruleName ] !== 'function') return console.warn('No validation rules specified for', ruleName, this.field);

				const result = this.rules[ ruleName ](this.inputVal, this.fieldValidation[ ruleName ]);
				if (result !== true) {
					this.errors.push(result);
				}
			});

			return this.errors;
		},

		/**
		 * Default validation rules that most fields abide by.
		 * Can be overwritten with addValidationRule('SAME_NAME', ...) or by setting this.rules = {} in mounted()
		 *
		 * @private
		 */
		_setDefaultValidationRules() {
			this.addValidationRule('required', (value) => {
				const isArray = _.isArray(value);
				if (isArray && value.length > 0) {
					return true;
				} else if (!isArray && value) { // && [ 'string', 'boolean' ].indexOf(typeof value) !== -1 Why limit to string/bool?
					return true;
				}

				return `The ${this.field.name.toLowerCase()} field is required`;
			});

			this.addValidationRule('url_slug', (value) => {
				return (RegExp(/^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/).test(value))
					? true
					: 'You must provide a valid URL slug';
			});

			this.addValidationRule('max', (value, [maxLength]) => {
				return (!value || value.length <= maxLength)
					? true
					: `This may not be greater than ${maxLength} characters`;
			});
		},
	},
};
